export type ImageFrame = {
  cropX: number;
  cropY: number;
  cropWidth: number;
  cropHeight: number;
  scale: number;
};

export function coverImageFrame(sourceWidth: number, sourceHeight: number, frameWidth: number, frameHeight: number, focalX = .5, focalY = .5): ImageFrame {
  const sw = Math.max(1, sourceWidth); const sh = Math.max(1, sourceHeight);
  const fw = Math.max(1, frameWidth); const fh = Math.max(1, frameHeight);
  const sourceRatio = sw / sh; const frameRatio = fw / fh;
  let cropWidth = sw; let cropHeight = sh;
  if (sourceRatio > frameRatio) cropWidth = sh * frameRatio;
  else cropHeight = sw / frameRatio;
  const cropX = (sw - cropWidth) * Math.max(0, Math.min(1, focalX));
  const cropY = (sh - cropHeight) * Math.max(0, Math.min(1, focalY));
  return { cropX, cropY, cropWidth, cropHeight, scale: fw / cropWidth };
}

export function containImageFrame(sourceWidth: number, sourceHeight: number, frameWidth: number, frameHeight: number): ImageFrame {
  const sw = Math.max(1, sourceWidth); const sh = Math.max(1, sourceHeight);
  return { cropX: 0, cropY: 0, cropWidth: sw, cropHeight: sh, scale: Math.min(Math.max(1, frameWidth) / sw, Math.max(1, frameHeight) / sh) };
}
